import React, { Component } from "react";
import { Container, Spinner, Row, Col, CardGroup, Card, CardBody, CardFooter, Form, UncontrolledTooltip, Button, InputGroup, Jumbotron, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { Field, reduxForm } from "redux-form";
import Proptypes from "prop-types";
import { NotificationManager } from "react-notifications";
import { withRouter } from "react-router";
import { connect } from "react-redux";
import $ from "jquery";
import { getLoginSettings } from "../../actions/actionLogin";
import { resetEmail, passwordReset } from "../../actions/actionPasswordReset";
import { required, renderField, email } from "../../utils/formValidations.js";
import "../../../assets/style/style.css";
import ReCAPTCHA from "react-google-recaptcha";
import queryString from "query-string";

class PasswordReset extends Component {
    constructor(props) {
        super(props);
        this.state = {
            recaptcha_needed: true,
            recaptcha_value: null,
            google_recaptcha_site_key: "6Le5qy4UAAAAAGSsuiAYVhAm4b_YlKFTIeTgch2e",
            error: true,
            loginBoxClass: "",
            loginClicked: false,
            authModal: false,
            brandingSet: false,
            do_reset: false,
            loginData: {},
            reset_username: null,
            reset_token: null,
        };
        this.handleReset = this.handleReset.bind(this);
        this.resetError = this.resetError.bind(this);
        this.toggle = this.toggle.bind(this);
        this.handleSuccess = this.handleSuccess.bind(this);
        this.handleComplete = this.handleComplete.bind(this);
        this.onCaptchaChange = this.onCaptchaChange.bind(this);
    }
    onCaptchaChange(value){
        this.setState({recaptcha_value: value});
    }

    handleReset({ username, password, password_confirm }) {

        if (!this.state.recaptcha_value){
            this.resetError("Please solve the reCAPTCHA.")
        }
        else{
            if (this.state.do_reset){
                if (password != password_confirm) {
                    this.resetError("The passwords do not match.")
                }
                else {
                    let login_data = {
                    "emailaddress": username.trim().toLowerCase(),
                    "password": password.trim(),
                    "recaptcha": this.state.recaptcha_value,
                    "reset_token": this.state.reset_token,
                    };
                    this.props.passwordReset(login_data).
                    then(() => this.handleSuccess(login_data)).
                    catch(() => this.resetError());
                }

            }
            else {
                let login_data = {
                    "emailaddress": username.trim().toLowerCase(),
                    "recaptcha": this.state.recaptcha_value
                };
                 this.props.resetEmail(login_data).
                    then(() => this.handleSuccess(login_data)).
                    catch(() => this.resetError());
             }
        }

    }

    resetError(error) {
        if (error || this.props.resetEmailError ) {
            this.setState({loginBoxClass: "login_error", error:false, loginClicked: false});
            NotificationManager.error(error || this.props.resetEmailError,"Password Reset Failed", 5000);
        }
    }



    handleSuccess() {
        if (this.props.resetEmailError) {
            this.setState({loginBoxClass: "login_error", error:false, loginClicked: false});
            NotificationManager.error(this.props.resetEmailError,"Password Reset Failed", 5000);
        }
        else{
           this.toggle();
        }


    }

    handleComplete(){
         window.location.href = "/#/";
    }


    toggle(){
        if (this.state.authModal){
            // The modal is being closed. Push the user to the login page
            this.handleComplete()
        }
        else{
           this.setState({authModal: !this.state.authModal, loginClicked: false});
        }
    }


    async componentDidMount() {
        const { response: settings } = await this.props.getLoginSettings();
        window.localStorage.setItem("login_logo", settings.login_logo);
        window.localStorage.setItem("login_caption", settings.login_caption);
        window.localStorage.setItem("header_logo", settings.header_logo);
        window.localStorage.setItem("login_splash_background", settings.login_splash_background);
        window.localStorage.setItem("splash_background", settings.splash_background);
        window.localStorage.setItem("html_title", settings.html_title);
        window.localStorage.setItem("favicon_logo", settings.favicon_logo);
        window.localStorage.setItem("loading_session_text", settings.loading_session_text);
        window.localStorage.setItem("joining_session_text", settings.joining_session_text);
        window.localStorage.setItem("destroying_session_text", settings.destroying_session_text);
        window.localStorage.setItem("launcher_background_url", settings.launcher_background_url);
        this.setState({brandingSet: true})

        if (window.localStorage.getItem("user_info") == null) {
            $("body").addClass("login-body");
        }  else {
            $("body").removeClass("login-body");
        }

        let reset_username = null;
        let reset_token = null;
        const values = queryString.parse(this.props.location.search);
        if (values.emailaddress) {
            reset_username = decodeURIComponent(values.emailaddress);
            this.setState({
                reset_username: decodeURIComponent(values.emailaddress),
            });
            this.props.initialize({username: reset_username});
        }
        if (values.token) {
              reset_token = decodeURIComponent(values.token);
              this.setState({
                reset_token: decodeURIComponent(values.token),
              });
        }
        if (reset_username && reset_token){
            this.setState({do_reset: true});
        }
    }

    componentWillUnmount() {
        $("body").removeClass("login-body");
    }

    render() {
        const {login_settings, handleSubmit } = this.props;

        let login_splash_background = window.localStorage.getItem('login_splash_background');
        let login_logo = window.localStorage.getItem('login_logo');
        login_logo = login_logo ? login_logo : '/img/logo.svg';
        let powered_by = login_logo != "/img/logo.svg";

        let login_caption = window.localStorage.getItem('login_caption');
        login_caption = login_caption ? login_caption : 'The Container Streaming Platform';


        let elem = document.getElementById("favicon");
        let favicon_logo = window.localStorage.getItem('favicon_logo');
        if (favicon_logo != undefined){
            elem.href=favicon_logo;
        }

        let html_title = window.localStorage.getItem('html_title');
        if (html_title != undefined){
             document.title=html_title;
        }

        return (
            <div >
                <div className="login_box" style={{backgroundImage: 'url("' + login_splash_background + '")'}}>
                    <div className={"login-flex " + this.state.loginBoxClass}>
                        <CardGroup className="mb-0">
                            <Card className="login-card">
                                <CardBody className="card-body col-md-offset-3 ">
                                    <div className="login-card-top">
                                    <h1 className="login-title"><strong>Password Reset</strong> </h1>

                                        <Form onSubmit={handleSubmit(this.handleReset)}>
                                        <InputGroup className="mb-3 login_form_field">
                                            <div className="input-group-prepend">
                                                <span className={`input-group-text`}>
                                                    <i className="fa fa-envelope-o" aria-hidden="true"></i>
                                                </span>
                                            </div>
                                            <Field
                                                name="username"
                                                placeholder="Your Email"
                                                component={renderField}
                                                type="text"
                                                validate={email}
                                            />
                                        </InputGroup>
                                        {this.state.do_reset ?
                                           <React.Fragment>
                                                <InputGroup className="mb-4 login_form_field">
                                                    <div className="input-group-prepend">
                                                        <span className={`input-group-text`}>
                                                            <i className="icon-lock"></i>
                                                        </span>
                                                    </div>
                                                    <Field
                                                        name="password"
                                                        placeholder="Your Password"
                                                        component={renderField}
                                                        type="password"
                                                        validate={required}
                                                    />
                                                </InputGroup>
                                                    <InputGroup className="mb-4 login_form_field">
                                                    <div className="input-group-prepend">
                                                        <span className={`input-group-text`}>
                                                            <i className="icon-lock"></i>
                                                        </span>
                                                    </div>
                                                    <Field
                                                        name="password_confirm"
                                                        placeholder="Confirm Your Password"
                                                        component={renderField}
                                                        type="password"
                                                        validate={required}
                                                    />

                                                </InputGroup>
                                           </React.Fragment>
                                              :
                                                ""
                                                }
                                            {this.state.recaptcha_needed ?
                                                <Row>
                                                    <div style={{
                                                        paddingTop: "20px",
                                                        textAlign: "center",
                                                        display: "inline-block",
                                                        paddingBottom: "20px"
                                                    }}>
                                                        {this.state.google_recaptcha_site_key ?
                                                            <ReCAPTCHA
                                                                sitekey={this.state.google_recaptcha_site_key}
                                                                onChange={this.onCaptchaChange}
                                                            />
                                                            : ""
                                                        }
                                                    </div>
                                                </Row>
                                                :
                                                ""
                                            }
                                        <Row>
                                            <Col xs="12">
                                                <div className="text-right">  {this.state.loginClicked ? <Spinner color="primary" className="login-spinner" /> : <Button color="primary" className="login-card-btn"  type="submit">Submit</Button>} </div>
                                            </Col>
                                        </Row>

                                    </Form>
                                    </div>


                                </CardBody>

                                {this.props.login_settings && this.props.login_settings.notice_message && this.props.login_settings.notice_title &&
                                        <div className="notice-box">
                                                <h4>{this.props.login_settings && this.props.login_settings.notice_title}</h4>
                                                <p>{this.props.login_settings && this.props.login_settings.notice_message}</p>
                                        </div>
                                        }
                            </Card>
                            <Card className="text-white logo-card   d-md-down-none">
                                <div className="logo-wrapper">
                                    <div className="logo-center">
                                    <img src={login_logo} alt="logo"/>
                                        <CardBody className="text-center">
                                            {powered_by ?
                                            <div className="logo-bottom-txt">
                                                <p>Powered by Kasm Workspaces</p>
                                            </div>
                                            :
                                            ""}
                                            <div className = "logo-bottom-txt">
                                                <h5>{login_caption}</h5>
                                            </div>
                                        </CardBody>
                                    </div>
                                </div>
                            </Card>
                        </CardGroup>
                        <Modal isOpen={this.state.authModal}  toggle={this.toggle} centered={true} className="user-modal confirm-modal">
                            <Form onSubmit={handleSubmit(this.toggle)}>
                                <ModalHeader toggle={this.toggle}>Success</ModalHeader>
                                {this.state.do_reset ?
                                    <ModalBody className="confirm-modal-body">
                                        Password reset complete. Please login with your new credentials.
                                    </ModalBody>
                                :
                                    <ModalBody className="confirm-modal-body">
                                        If an account by that name exists a confirmation email will be sent. Please click the link in the confirmation email to reset your password.
                                    </ModalBody>
                                }

                                <ModalFooter>
                                    <Button type= "submit" size="sm" color="primary" className="submit-button">OK</Button>
                                </ModalFooter>
                            </Form>
                        </Modal>
                    </div>
                </div>
            </div>
        );
    }
}

PasswordReset.propTypes = {
    resetEmail: Proptypes.func.isRequired,
    fields: Proptypes.array,
    handleSubmit: Proptypes.func,
    isLoggedIn: Proptypes.bool,
    has2fa: Proptypes.bool,
    new_two_factor: Proptypes.bool,
    user_info: Proptypes.object,
    resetError: Proptypes.string,
    history: Proptypes.object,
    initialize: Proptypes.func,
};

PasswordReset = withRouter(PasswordReset);

function mapStateToProps(state) {
    return {
        isLoading: state.passwordReset.resetEmailLoading,
        resetEmailError: state.passwordReset.resetEmailError,
        resetEmailSuccess: state.passwordReset.resetEmailSuccess,
        login_settings: state.auth.login_settings,
    };
}

function mapDispatchToProps(dispatch) {
    return ({
        getLoginSettings: () => dispatch(getLoginSettings()),
        resetEmail: (data) => dispatch(resetEmail(data)),
        passwordReset: (data) => dispatch(passwordReset(data)),
    });
}

let PasswordResetWithRouter =  withRouter(PasswordReset);

let PasswordResetComponent = connect(
    mapStateToProps,
    mapDispatchToProps
)(PasswordResetWithRouter);

export default reduxForm({
    form: "PasswordResetPageForm",
    fields: ["username", "password"]
})(PasswordResetComponent);